/* src/app/ships/ship-details/ship-details.component.css */
/*# sourceMappingURL=ship-details.component.css.map */
